import React from 'react';
import { View } from '@amzn/atoz-web/View';
import { Text } from '@amzn/atoz-web/Text';
import { Row } from '@amzn/atoz-web/Row';
import { useTranslation } from 'react-i18next';
import { useShiftDetailsCardData } from './utils';
import { ShiftInfo } from '../../ShiftInfo';
import { VTOAccepted } from '../VTO/VTOAccepted';
import { VTOAvailable } from '../VTO/VTOAvailable';
export var ShiftDetailsCard = function (_a) {
    var scheduleShift = _a.scheduleShift, shift = _a.shift, skills = _a.skills, payBreakdown = _a.payBreakdown, setModalContent = _a.setModalContent, setModalError = _a.setModalError, vtoOpportunities = _a.vtoOpportunities;
    var t = useTranslation().t;
    var _b = useShiftDetailsCardData({ scheduleShift: scheduleShift, shift: shift, skills: skills }), isVtoEnabled = _b.isVtoEnabled, title = _b.title, address = _b.address, displayedSkills = _b.displayedSkills;
    return (React.createElement(View, { dataTestId: "ShiftDetailsCard" },
        React.createElement(Text, { dataTestId: "ShiftDetailsCard-title" }, title),
        React.createElement(View, { backgroundColor: "neutral05", padding: ['S300', 'S400'], margin: { top: 'S100' } },
            React.createElement(ShiftInfo, { shift: shift, skills: displayedSkills, payBreakdown: payBreakdown }),
            address && (React.createElement(Row, null,
                React.createElement(Text, { fontSize: "T200", dataTestId: "ShiftDetailsCard-address" },
                    t('shift_management_features_ShiftDetailsCard_address'),
                    ": ",
                    address))),
            isVtoEnabled && (React.createElement(React.Fragment, null,
                React.createElement(View, { margin: { top: 'S200' } },
                    React.createElement(VTOAccepted, { scheduleShift: scheduleShift })),
                React.createElement(View, { margin: { top: 'S200' } },
                    React.createElement(VTOAvailable, { setModalContent: setModalContent, setModalError: setModalError, vtoOpportunities: vtoOpportunities })))))));
};
